import React from 'react';
import { Layout } from 'lucide-react';

export const LayoutEditorHint: React.FC = () => {
  return (
    <div className="mb-4 p-4 bg-purple-50 border border-purple-200 rounded-lg">
      <div className="flex items-start space-x-3">
        <Layout className="w-5 h-5 text-purple-600 mt-0.5" />
        <div>
          <h3 className="text-sm font-medium text-purple-900">Layout Editor</h3>
          <p className="mt-1 text-sm text-purple-700">
            Add components like Navbar and Footer that will wrap around your page content. The{' '}
            <strong>Content Area</strong> component marks where page-specific content will appear.
          </p>
        </div>
      </div>
    </div>
  );
};
